interface Props {
  title: string;
  onBack: () => void;
  disabled?: boolean;
}

// A compact back-arrow + title row at the top of every wizard step past
// the entry screen, replacing a plain <h1> and a separate full-width
// "Back" button at the bottom — matches the approved mockup's compare-
// options screen (https://claude.ai/code/artifact/ae3ec6ef).
export default function StepHeader({ title, onBack, disabled }: Props) {
  return (
    <div className="step-header">
      <button type="button" className="icon-btn" onClick={onBack} disabled={disabled} aria-label="Back">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M19 12H5M11 5l-7 7 7 7" />
        </svg>
      </button>
      <h2>{title}</h2>
    </div>
  );
}
